<template>
  <svg
    class="brand-logo"
    :viewBox="viewBox"
    aria-hidden="true"
    focusable="false"
  >
    <defs v-if="mode === 'reveal'">
      <mask
        v-for="wave in waves"
        :key="wave.key"
        :id="maskId(wave.key)"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        :width="width"
        :height="height"
      >
        <rect
          :class="['logo-reveal', `logo-reveal--${wave.key}`]"
          x="0"
          y="-6"
          width="286"
          height="152"
          fill="#fff"
        />
      </mask>
    </defs>

    <!-- mask di g, bukan di path: transform path bikin area mask-nya meleset -->
    <g v-for="wave in waves" :key="wave.key" :mask="maskRef(wave.key)">
      <path :d="wave.d" :transform="transform" :fill="wave.color" />
    </g>
  </svg>
</template>

<script>
import {
  LOGO_WAVES, LOGO_VIEW_BOX, LOGO_TRANSFORM, LOGO_WIDTH, LOGO_HEIGHT,
} from '@/util/auth/brandLogoPaths';

// tiap logo dapat nomornya sendiri biar id mask gak kembar antar instance
let instanceSeq = 0;

export default {
  name: 'AuthBrandLogo',
  props: {
    mode: {
      type: String,
      default: 'plain',
      validator: (value) => ['plain', 'reveal'].includes(value),
    },
  },
  data() {
    instanceSeq += 1;
    return { uid: instanceSeq };
  },
  computed: {
    waves() { return LOGO_WAVES; },
    viewBox() { return LOGO_VIEW_BOX; },
    transform() { return LOGO_TRANSFORM; },
    width() { return LOGO_WIDTH; },
    height() { return LOGO_HEIGHT; },
  },
  methods: {
    maskId(key) { return `mtz-reveal-${key}-${this.uid}`; },
    maskRef(key) { return this.mode === 'reveal' ? `url(#${this.maskId(key)})` : null; },
  },
};
</script>
